import { UseControllerProps, useController } from "react-hook-form";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { isValid, format as dfFormat } from "date-fns";
import { enGB } from "date-fns/locale"; // or enIE from date-fns@3
import { Grid } from "@mui/material"; // Grid2 uses the `size` prop
import AppInformationText from "./AppInformationText";
import { CalendarPickerView } from "@mui/lab"; // if you need the type

interface Props extends UseControllerProps {
  label: string;
  views?: CalendarPickerView[];        // or CalendarPickerView[]
  minDate?: Date | null;
  maxDate?: Date | null;
  information_text?: string;
  disabled?: boolean;
  validateInvalidInput?: boolean;
}

const AppDatePicker = (props: Props) => {
  const { field, fieldState } = useController({ ...props });

  return (
    <Grid container rowSpacing={4}>
      <Grid size={{ xs: 11 }}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <DesktopDatePicker
            label={props.label}
            value={field.value ?? null}              // Date | null
            onChange={(newValue) => {
              if (props.validateInvalidInput || newValue === null || isValid(newValue)) {
                field.onChange(newValue);
              }
            }}
            minDate={props.minDate ?? undefined}
            maxDate={props.maxDate ?? undefined}
            // ✅ date-fns tokens (NOT dayjs):
            format="dd/MM/yyyy"
            views={props.views}
            disabled={props.disabled}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!fieldState.error,
                helperText: fieldState.error?.message,
                className: "rcsiTextField",
                sx: props.disabled ? { backgroundColor: "#FAFAFA", color: "#858282" } : {},
                // don't spread `field` here—MUI manages the input
              },
            }}
          />
        </LocalizationProvider>
      </Grid>

      <Grid size={{ xs: 1 }}>
        <AppInformationText information_text={props.information_text} />
      </Grid>
    </Grid>
  );
};

export default AppDatePicker;
